import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ROUTE_DASHBOARD, ROUTE_RECOMMENDATIONS } from '../../constants';
import Suspense from '../../services/lazyLoad/Suspense';
import { useRecommendationsEntitled } from '../../utils/recommendationsEntitlement';

const Recommendations = React.lazy(() => import('./Recommendations'));

export default function RecommendationsWrapper() {
  const isEntitled = useRecommendationsEntitled();

  if (!isEntitled) {
    return <Redirect to={ROUTE_DASHBOARD.path} />;
  }

  return (
    <Suspense>
      <Switch>
        <Route exact path={ROUTE_RECOMMENDATIONS.path}>
          <Recommendations />
        </Route>
        <Redirect exact path="/*" to={ROUTE_RECOMMENDATIONS.path} />
      </Switch>
    </Suspense>
  );
}
